import React, { useEffect, useState } from 'react';
import img from '../../static/img/vm/vm-logo-wordmark.png'
import './header.css'

interface menuObject {
    title: string;
    submenu?: {title: string, link: string}[] ;
    link?: string;
}

export default function Header() {
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState<menuObject | null>(null);

    const [menu] = useState<menuObject[]>([
        {title: 'Our Business', submenu: [{title: 'Our Story', link: '/about/our-story'}, {title: 'Our Vision', link: '/about/vision'}, {title: 'Our Approach', link: '/about/our-approach'},  {title: 'Partnership', link: '/about/partnership'}]},
        {title: 'Our Partners', link: '/our-wines'},
        {title: 'Trade', submenu: [{title: 'Order Online', link: 'https://vinimark.mobi/logon.aspx?ReturnUrl=%2f'}, {title: 'Trade With Us', link: '/trade-with-us'}, {title: 'International', link: '/about/international'}]},
        {title: 'Careers', link: '/vacancies'},
        {title: 'News', submenu: [{title: 'Stories', link: '/news'}, {title: 'Webinars', link: '/webinars'}, {title: 'Podcasts', link: '/podcasts'}, {title: 'Galleries', link: '/galleries'}]},
        {title: 'Login', link: '/customer-login'},
        {title: 'Contact', link: '/contact'},
        {title: 'Search', link: '/search'}
    ]);

    useEffect(() => {
        function handleResize() {
            setScreenSize(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function getMobile() {
        return (
            <div className="header">
                <div className="header-left" style={{ paddingTop: "5px" }}>
                    <a href="/">
                        <img
                            src={img}
                            alt="VM Logo"
                            fetchPriority="high"
                            decoding="async"
                            style={{ width: "160px", height: "21.5px" }}
                        />
                    </a>
                </div>

                <div
                    className="header-right-mobile"
                    onClick={() => {
                        if (menuOpen) {
                            setActiveMenu(null);
                        }
                        setMenuOpen(!menuOpen);
                    }}
                >
                    {menuOpen ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="hamburger-icon"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="hamburger-icon"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                            />
                        </svg>
                    )}
                </div>

                {menuOpen && (
                    <>
                        <div
                            className="sidebar-overlay"
                            onClick={() => {
                                setMenuOpen(false);
                                setActiveMenu(null);
                            }}
                        />

                        <div className="sidebar-left-mobile">
                            {activeMenu ? (
                                <>
                                    <div
                                        className="sidebar-header"
                                        onClick={() => setActiveMenu(null)}
                                    >
                                    <span
                                        style={{
                                            fontSize: "22px",
                                            fontWeight: 100,
                                        }}
                                    >
                                        &lt;
                                    </span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {activeMenu.title}
                                    </div>

                                    <ul className="submenu-list">
                                        {activeMenu.submenu?.map((sub, index) => (
                                            <li key={index}>
                                                <a
                                                    target={
                                                        sub.link ===
                                                        "https://vinimark.mobi/logon.aspx?ReturnUrl=%2f"
                                                            ? "_blank"
                                                            : "_self"
                                                    }
                                                    href={sub.link}
                                                >
                                                    {sub.title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <ul className="menu-list">
                                    {menu.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() => {
                                                if (item.submenu) {
                                                    setActiveMenu(item);
                                                } else if (item.link) {
                                                    window.location.href = item.link;
                                                }
                                            }}
                                        >
                                            {item.title}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </>
                )}
            </div>
        );
    }

    function getDesktop() {
        return (
            <div style={{width:'100%'}}>
                <div className="header" style={{marginBottom: '10px', marginTop: '10px'}}>
                    <div className="header-right">
                        <a href="/">
                            <img src={img} alt="VM Logo"
                                 fetchPriority="high"
                                 decoding="async"
                                 style={{ width: '160px', paddingTop: '10px', paddingBottom: '10px', marginLeft: '16px' , height: '21.5px'}} /></a>
                    </div>
                    <div className="header-left" >
                        <ul className="header-nav-menu">
                            {menu.map((item, index) => (
                                <li className="header-nav-item" key={index}>
                                    {item.link ? (
                                        <a href={item.link}>{item.title}</a>
                                    ) : (
                                        <span style={{cursor: "pointer"}}>{item.title}</span>
                                    )}

                                    {item.submenu && (
                                        <>
                                            {/* dropdown background */}
                                            <div className="submenu-dropdown"></div>

                                            {/* actual submenu items */}
                                            <ul className="submenu">
                                                {item.submenu.map((sub, subIndex) => (
                                                    <li key={subIndex}>
                                                        <a target={sub.link == 'https://vinimark.mobi/logon.aspx?ReturnUrl=%2f' ? '_blank' : '_self'} href={sub.link}>{sub.title}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>


                    </div>
                </div>
            </div>
        );
    }


    let content;
    if (screenSize < 835) {
        content = getMobile();
    } else if (screenSize > 1300) {
        content = getDesktop();
    } else {
        content = getMobile();
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            zIndex: 1000,
            color: 'black'
        }}>
            {content}
        </div>
    );
}
